import { createEnumFilter } from '@spotify/confidence-core-react';
import { DecisionRecordDataOutcome } from '@spotify/confidence-graphql';

export const OUTCOME_FILTER = createEnumFilter<DecisionRecordDataOutcome>({
  id: 'outcome',
  label: 'Outcome',
  field: 'module_data.decision.outcome',
  enum: [
    DecisionRecordDataOutcome.Shipped,
    DecisionRecordDataOutcome.Abandoned,
    DecisionRecordDataOutcome.Aborted,
    DecisionRecordDataOutcome.Restarted,
  ],
});
